export function createEmptyPatientDraft() {
  const now = new Date();
  const formatted =
  String(now.getMonth() + 1).padStart(2, "0") + "-" +
  String(now.getDate()).padStart(2, "0") + "-" +
  now.getFullYear() + " " +
  String(now.getHours()).padStart(2, "0") + ":" +
  String(now.getMinutes()).padStart(2, "0");
  return {
    demographics: {
      first_name: "",
      middle_name: "",
      last_name: "",
      dob: "",
      street_address: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      sex: "",
      race: "",
      highest_education_level: "",
    },
    test: {
      testDate: "",
      testType: "",
      results: null,
    },
    meta: {
      createdAt: formatted,
    },
  };
}
